import type { SVGProps } from "react";

export const GoogleHotels = (props: SVGProps<SVGSVGElement>) => (
  <svg
    height="1em"
    preserveAspectRatio="xMidYMid"
    viewBox="95 0 320.808 512"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <title>Google Hotels</title>{" "}
    <g fill="none" fillRule="evenodd">
      {" "}
      <path
        d="M175.034 21.925C175.034 9.816 184.85 0 196.96 0h118.41c12.11 0 21.926 9.815 21.926 21.925v118.41c0 12.11-9.815 21.926-21.926 21.926H196.96c-12.11 0-21.926-9.815-21.926-21.925zm39.47 15.351v82.227h82.226V37.276zM173.39 512c-22.707 0-41.114-18.407-41.114-41.113 0-22.707 18.407-41.114 41.114-41.114 22.706 0 41.113 18.407 41.113 41.114 0 22.706-18.407 41.113-41.113 41.113zm164.454 0c-22.707 0-41.114-18.407-41.114-41.113 0-22.707 18.407-41.114 41.114-41.114s41.113 18.407 41.113 41.114c0 22.706-18.407 41.113-41.113 41.113z"
        fill="#1967d2"
      />{" "}
      <rect
        fill="#4285f4"
        height="373.859"
        rx="39.469"
        width="322.33"
        x="95"
        y="95.383"
      />{" "}
      <path
        d="M95 134.862v294.901c0 4.114.629 8.08 1.795 11.809l159.516-159.516-159.32-159.61A39.447 39.447 0 0 0 95 134.862z"
        fill="#fbbc04"
      />{" "}
      <path
        d="M255.904 282.86l.804-.804.805.805zM97.389 122.447c5.204-15.72 20.017-27.063 37.472-27.063h243.403c17.54 0 32.408 11.446 37.544 27.282l-159.1 159.1z"
        fill="#ea4335"
      />{" "}
      <path
        d="M255.707 281.764l.805.805.804-.805zM97.193 442.18c5.203 15.72 20.017 27.062 37.471 27.062h243.403c17.54 0 32.408-11.445 37.544-27.281l-159.1-159.1z"
        fill="#34a853"
      />{" "}
      <circle cx="256.165" cy="281.764" fill="#4285f4" r="78.938" />{" "}
      <path
        d="M350.714 265.627a107.857 107.857 0 0 1 1.838 19.915c0 54.176-36.333 92.702-91.196 92.702-52.487 0-95-42.44-95-94.835 0-52.396 42.513-94.835 95-94.835 25.652 0 47.082 9.423 63.532 24.716l-26.783 26.733v-.061c-9.973-9.485-22.619-14.344-36.75-14.344-31.348 0-56.82 26.435-56.82 57.733 0 31.29 25.472 57.79 56.82 57.79 28.442 0 47.796-16.242 51.78-38.527h-51.78v-36.987z"
        fill="#fff"
        fillRule="nonzero"
      />{" "}
    </g>
  </svg>
);

export default GoogleHotels;
